import { render, staticRenderFns } from "./DomainDNS.vue?vue&type=template&id=1023715c&scoped=true&"
import script from "./DomainDNS.vue?vue&type=script&lang=js&"
export * from "./DomainDNS.vue?vue&type=script&lang=js&"
import style0 from "./DomainDNS.vue?vue&type=style&index=0&id=1023715c&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1023715c",
  null
  
)

export default component.exports